import { useProjectChildMultiActions } from "entities/projects/model/useProjectChildMultiActions"

import { ProjectChildMultiSelectSidebarProps } from "../ProjectChildMultiSelectSidebar"
import { ProjectChildMultiSelectSidebarViewModel } from "../ProjectChildMultiSelectSidebarView"

export function useProjectChildMultiSelectSidebarViewModel({
  callbacks,
  selectedChildren,
  isDisabled,
  ...rest
}: ProjectChildMultiSelectSidebarProps): ProjectChildMultiSelectSidebarViewModel {
  const selectedChildCount = selectedChildren.length

  const { actions } = useProjectChildMultiActions({
    ...callbacks,
    isDeleteDisabled: isDisabled
  })

  return { ...rest, selectedChildCount, actions }
}
